(function () {
    var pulse = document.querySelector('[data-repo-pulse]');

    if (!pulse || !window.fetch) {
        return;
    }

    var cards = Array.prototype.slice.call(pulse.querySelectorAll('[data-repo]'));

    function render(card, repo) {
        var figures = card.querySelector('[data-repo-figures]');

        card.querySelector('[data-repo-stars]').textContent = repo.stargazers_count;
        card.querySelector('[data-repo-forks]').textContent = repo.forks_count;
        card.querySelector('[data-repo-watchers]').textContent = repo.subscribers_count || repo.watchers_count;

        figures.hidden = false;
    }

    cards.forEach(function (card) {
        fetch('https://api.github.com/repos/' + card.getAttribute('data-repo'), {
            headers: {Accept: 'application/vnd.github+json'}
        }).then(function (response) {
            return response.ok ? response.json() : Promise.reject();
        }).then(function (repo) {
            render(card, repo);
        }).catch(function () {
        });
    });
})();
